import { Marker } from "@teovilla/react-native-web-maps";

export default Marker;